import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import capitalize from 'lodash/capitalize';
import { applyRounding, longDateString, numberWithCommas, parseNumCheckNull } from '../../../lib/formatters';
import AdvancedCell from '../../../AdvancedTable/AdvancedCell';
import DeleteModal from './DeleteModal/DeleteModal';

const addZero = num => (num < 10 ? `0${num}` : `${num}`);
class JobRangesTableRow extends Component {
  static propTypes = {
    status: PropTypes.string,
    id: PropTypes.number,
    rangeType: PropTypes.string,
    lastModifiedDate: PropTypes.string,
    jobCount: PropTypes.number,
    name: PropTypes.string,
    deleteModel: PropTypes.func,
    history: PropTypes.object,
    settings: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = { deleteModalViz: false };
  }

  showModal = () => {
    this.setState({ deleteModalViz: true });
  };

  hideModal = () => {
    this.setState({ deleteModalViz: false });
  };

  onDelete = () => {
    this.props.deleteModel(this.props.original.id);
    this.hideModal();
  };

  renderModal = () => {
    const { deleteModalViz } = this.state;
    const { original } = this.props;

    return (
      <DeleteModal
        visible={deleteModalViz}
        onClickAway={this.hideModal}
        modelName={original.name}
        onDelete={this.onDelete}
      />
    );
  };

  showDetailRoute = () => {
    const { original, history } = this.props;
    history.push(`/ranges/${original.id}`);
  };

  render() {
    const {
      rangeType,
      jobCount,
      lastModifiedDate,
      name,
      created,
      currentCostToMax,
      currentCostToMin,
      currentEmployeesAboveMax,
      currentEmployeesBelowMin,
      proposedCostToMax,
      proposedCostToMin,
      proposedEmployeesAboveMax,
      proposedEmployeesBelowMin,
      payType,
      currentDate,
      employeeCount,
      currentAvgCompRatio,
      currentAvgRangePen,
      proposedAvgCompRatio,
      proposedAvgRangePen,
      preferences,
      original
    } = this.props;
    const { deleteModalViz } = this.state;
    const createdDate = original.created || original.lastModifiedDate;
    const prettyCreatedDate = new Date(createdDate);
    const prettyCurrentDate = new Date(original.currentDate);

    return (
      <React.Fragment>
        <AdvancedCell
          getCellProps={this.props.cells[0].getCellProps}
          className="jobRanges__bodycell"
          onClick={this.showDetailRoute}
        >
          {original.name}
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[1].getCellProps}
          className="jobRanges__bodycell"
          onClick={this.showDetailRoute}
        >
          {capitalize(original.rangeType)}
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[2].getCellProps}
          className="jobRanges__bodycell center-align"
          onClick={this.showDetailRoute}
        >
          {numberWithCommas(original.jobCount) || 0}
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[3].getCellProps}
          className="jobRanges__bodycell center-align"
          onClick={this.showDetailRoute}
        >
          {numberWithCommas(original.employeeCount) || 0}
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[4].getCellProps}
          className="jobRanges__bodycell stacked__cell center-align"
          onClick={this.showDetailRoute}
        >
          <span className="current__value">
            {original.currentEmployeesBelowMin ? numberWithCommas(original.currentEmployeesBelowMin) : '-'}
          </span>
          <span className="proposed__value">
            {original.proposedEmployeesBelowMin ? numberWithCommas(original.proposedEmployeesBelowMin) : '-'}
          </span>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[5].getCellProps}
          className="jobRanges__bodycell stacked__cell center-align"
          onClick={this.showDetailRoute}
        >
          <span className="current__value">
            {original.currentEmployeesAboveMax ? numberWithCommas(original.currentEmployeesAboveMax) : '-'}
          </span>
          <span className="proposed__value">
            {original.proposedEmployeesAboveMax ? numberWithCommas(original.proposedEmployeesAboveMax) : '-'}
          </span>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[6].getCellProps}
          className="jobRanges__bodycell stacked__cell center-align"
          onClick={this.showDetailRoute}
        >
          <span className="current__value">
            {parseNumCheckNull(applyRounding(original.currentCostToMin, 'monetary', preferences))}
          </span>
          <span className="proposed__value">
            {parseNumCheckNull(applyRounding(original.proposedCostToMin, 'monetary', preferences))}
          </span>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[7].getCellProps}
          className="jobRanges__bodycell stacked__cell center-align"
          onClick={this.showDetailRoute}
        >
          <span className="current__value">
            {parseNumCheckNull(applyRounding(original.currentCostToMax, 'monetary', preferences))}
          </span>
          <span className="proposed__value">
            {parseNumCheckNull(applyRounding(original.proposedCostToMax, 'monetary', preferences))}
          </span>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[8].getCellProps}
          className="jobRanges__bodycell stacked__cell center-align"
          onClick={this.showDetailRoute}
        >
          <span className="current__value">
            {applyRounding(original.currentAvgCompRatio * 100, 'percent', preferences) || '-'}
          </span>
          <span className="proposed__value">
            {applyRounding(original.proposedAvgCompRatio * 100, 'percent', preferences) || '-'}
          </span>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[9].getCellProps}
          className="jobRanges__bodycell stacked__cell center-align"
          onClick={this.showDetailRoute}
        >
          <span className="current__value">
            {applyRounding(original.currentAvgRangePen * 100, 'percent', preferences) || '-'}
          </span>
          <span className="proposed__value">
            {applyRounding(original.proposedAvgRangePen * 100, 'percent', preferences) || '-'}
          </span>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[10].getCellProps}
          className="jobRanges__bodycell"
          onClick={this.showDetailRoute}
        >
          {(original.jobCount || 0) &&
          original.currentCostToMin === original.proposedCostToMin &&
          original.currentCostToMax === original.proposedCostToMax
            ? longDateString(prettyCurrentDate)
            : '-'}
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[11].getCellProps}
          className="jobRanges__bodycell"
          onClick={this.showDetailRoute}
        >
          {longDateString(prettyCreatedDate)}
        </AdvancedCell>
        <AdvancedCell
          getCellProps={this.props.cells[12].getCellProps}
          className="jobRanges__bodycell jobRanges__delete"
        >
          <i className="icon-trash" onClick={this.showModal} data-test-id="jbr-delete-model-button" />
          {deleteModalViz && this.renderModal()}
        </AdvancedCell>
      </React.Fragment>
    );
  }
}

export default withRouter(JobRangesTableRow);
